import React from "react";
const TermsOfService = () => {
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 w-full overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-200/30 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
      <div className="relative max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex px-5 py-2 bg-white rounded-full shadow-md mb-4">
            <span className="text-sm font-semibold text-red-600">
              Legal Agreement
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900">
            Terms of{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Service
            </span>
          </h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
            Last updated: January 1, 2024
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100">
          <div className="p-6 md:p-10">
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Agreement to Terms
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                By accessing or using the website of Asha Modern School ("we," "our," or "us"), 
                you agree to be bound by these Terms of Service. If you disagree with any part of 
                these terms, you may not access the website or use our services.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                These Terms apply to all visitors, users, parents, guardians, and others who access 
                or use our website and services.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Eligibility
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                By using our website and services, you represent and warrant that you are at least 
                18 years of age or are accessing the website with parental consent. If you are a 
                parent or guardian enrolling a child, you accept these terms on behalf of your child.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                School Services
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                Asha Modern School provides educational services including but not limited to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Academic programs from pre-primary to secondary education</li>
                <li>Extracurricular activities including sports, arts, and music</li>
                <li>Transportation services</li>
                <li>After-school care programs</li>
                <li>Parent-teacher communication portal</li>
                <li>Online fee payment system</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                User Responsibilities
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                As a user of our website and services, you agree to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Provide accurate and complete information during registration</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
                <li>Comply with all school policies and code of conduct</li>
                <li>Pay all fees and charges on time as per the fee schedule</li>
                <li>Ensure children follow school rules and discipline guidelines</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Prohibited Activities
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                You may not access or use the website for any purpose other than that for which we 
                make the website available. Prohibited activities include:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Unauthorized copying or distribution of school materials</li>
                <li>Attempting to interfere with website security features</li>
                <li>Posting false, misleading, or defamatory information</li>
                <li>Harassing or bullying staff members or other parents/students</li>
                <li>Using automated systems to access the website</li>
                <li>Violating any applicable laws or regulations</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Fees and Payments
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                All fees for school services are outlined in the admission agreement and fee schedule. 
                By enrolling your child, you agree to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Pay all applicable fees by the specified due dates</li>
                <li>Understand that late payments may incur additional charges</li>
                <li>Acknowledge that fees are non-refundable after the specified refund period</li>
                <li>Provide valid payment information for automated transactions</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Attendance and Withdrawal
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                Regular attendance is mandatory for all enrolled students. Parents must:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Inform the school about any absences in advance</li>
                <li>Provide valid medical certificates for extended absences</li>
                <li>Submit written notice for withdrawal at least 30 days in advance</li>
                <li>Settle all outstanding dues before withdrawal</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Code of Conduct
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                All students, parents, and staff must adhere to the school's code of conduct:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm ml-4">
                <li>Respect all members of the school community</li>
                <li>Maintain discipline and follow school rules</li>
                <li>Wear proper uniform as prescribed by the school</li>
                <li>Keep the school premises clean and tidy</li>
                <li>Participate actively in academic and extracurricular activities</li>
              </ul>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Intellectual Property
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                All content on this website, including text, graphics, logos, images, and software, 
                is the property of Asha Modern School and is protected by copyright laws. You may 
                not reproduce, distribute, or create derivative works without our express written 
                consent.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Limitation of Liability
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                To the fullest extent permitted by law, Asha Modern School shall not be liable for 
                any indirect, incidental, special, consequential, or punitive damages arising out of 
                your use of our website or services. We do not guarantee uninterrupted or error-free 
                operation of our website.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Termination
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We may terminate or suspend your access to our services immediately, without prior 
                notice, for conduct that we believe violates these Terms or is harmful to other users, 
                the school, or third parties. Upon termination, your right to use the services will 
                immediately cease.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Changes to Terms
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We reserve the right to modify these Terms at any time. We will notify users of any 
                material changes by posting the new Terms on this page. Your continued use of the 
                website after such changes constitutes your acceptance of the new Terms.
              </p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Governing Law
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of India, 
                without regard to its conflict of law provisions. Any legal disputes arising from 
                these Terms shall be resolved in the courts of Varanasi, Uttar Pradesh.
              </p>
            </div>
            <div className="mb-6">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                Contact Us
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                If you have any questions about these Terms of Service, please contact us:
              </p>
              <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-5">
                <p className="text-gray-700 text-sm mb-2">
                  <strong className="text-red-600">Asha Modern School</strong>
                </p>
                <p className="text-gray-600 text-sm mb-1">
                  Address: Address 2, Mani Nagar, Kandwa Road, Chitaipur, Varanasi
                </p>
                <p className="text-gray-600 text-sm mb-1">
                  Phone: +91-9839961911
                </p>
                <p className="text-gray-600 text-sm">
                  Email: info@ashamodernschool.com
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-5 border-l-4 border-red-600">
              <p className="text-gray-700 text-sm">
                <strong>By using our website and services, you acknowledge that you have read, understood, 
                and agree to be bound by these Terms of Service.</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-8">
          <button 
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-orange-500 text-white font-semibold text-sm py-2.5 px-6 rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};
export default TermsOfService;